import { render } from "./media.container.vue?vue&type=template&id=03d6bfb2"
import script from "./media.container.vue?vue&type=script&lang=js"
export * from "./media.container.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__